/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BaseErrorMessage.vue?vue&type=template&id=26a0d132"
import script from "./BaseErrorMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseErrorMessage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports